import {UserDTO} from "@/model/user";
import {DATE_FORMAT} from "@/common/constant";
import moment from "moment";
import CompanyLicense, {CompanyLicenseDTO} from "@/model/companyLicense";

export enum COMPANY_ROLE {
  MANAGE = 1,
  WITNESS = 2,
  OWNER = 3,
}

export const COMPANY_ROLE_NAME = {
  [COMPANY_ROLE.MANAGE]: "管理会社",
  [COMPANY_ROLE.WITNESS]: "立会業者",
  [COMPANY_ROLE.OWNER]: "オーナー",
}

export enum STATUS {
  WAIT = 0,
  JOIN = 1,
}

export const STATUS_NAME = {
  [STATUS.WAIT]: "wait",
  [STATUS.JOIN]: "join",
}

export class CompanyLicenseItem {
  id: string;
  license_num: string;
  applicable_date: string;
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}

export interface ICompany {
  id: string;
  name: string;
  zip_code: string;
  address1: string;
  address2: string;
  representative_user_id: string;
  representative_user: UserDTO;
  cooperate_count: number;
  companies_cooperate: any[];
  role_id: COMPANY_ROLE;
  is_allow_link: number;
  phone: string;
  fax: string;
  bank_info: string;
  transfer_date_number: number;
  pivot: {
    company_id: string,
    user_id: string,
    role_id: number,
    status: number,
    type: number,
    id: string,
    affiliation_company_id: string,
  };
  belongs_to_company: {
    cooperate_id: string,
    cooperate_status: string,
  };
  manager_companies: any[];
  manager_users: UserDTO[];
  witness_users: UserDTO[];
  owner_users: UserDTO[];
  license_is_active: CompanyLicenseDTO;
  license_is_oldest: CompanyLicenseDTO;
  company_licenses: CompanyLicenseItem[];
  licenses: CompanyLicenseDTO[];
}

export class CompanyDTO implements ICompany {
  id: string;
  name: string;
  zip_code: string;
  address1: string;
  address2: string;
  representative_user_id: string;
  representative_user: UserDTO;
  cooperate_count: number;
  companies_cooperate: any[];
  role_id: COMPANY_ROLE;
  is_allow_link: number;
  phone: string;
  fax: string;
  bank_info: string;
  transfer_date_number: number;
  pivot: {
    company_id: string,
    user_id: string,
    role_id: number,
    status: number,
    type: number,
    id: string,
    affiliation_company_id: string,
  };
  belongs_to_company: {
    cooperate_id: string,
    cooperate_status: string,
  };
  manager_companies: any[];
  manager_users: UserDTO[];
  witness_users: UserDTO[];
  owner_users: UserDTO[];
  license_is_active: CompanyLicenseDTO;
  license_is_oldest: CompanyLicenseDTO;
  company_licenses: CompanyLicenseItem[];
  licenses: CompanyLicenseDTO[];
}

export default class Company extends CompanyDTO {
  constructor(dto?: CompanyDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: "",
      zip_code: "",
      address1: "",
      address2: "",
      representative_user_id: "",
      representative_user: null,
      cooperate_count: 0,
      companies_cooperate: null,
      is_allow_link : 1,
      role_id: COMPANY_ROLE.MANAGE,
      phone: null,
      fax: null,
      bank_info: null,
      transfer_date_number: 0,
      pivot: {
        company_id: "",
        user_id: "",
        role_id: null,
        status: null,
        type: null,
        id: null,
        affiliation_company_id: null,
      },
      belongs_to_company: {
        cooperate_id: null,
        cooperate_status: null,
      },
      manager_companies: [],
      manager_users: [],
      witness_users: [],
      owner_users: [],
      license_is_active: new CompanyLicense(),
      license_is_oldest: new CompanyLicense(),
      company_licenses: [],
    });
  }

  get location() {
    return this.address1 + (this.address2 ? this.address2 : "");
  }

  get representativeUserName() {
    return this.representative_user ? this.representative_user.username : null;
  }

  get roleName() {
    return this.getRoleName(this.role_id);
  }

  get linkStatus() {
    return this.is_allow_link === 1 ? "on" : "off";
  }

  get managerUsersCount() {
    return this.manager_users ? this.manager_users.length : 0;
  }

  get witnessUsersCount() {
    return this.witness_users ? this.witness_users.length : 0;
  }

  get ownerUsersCount() {
    return this.owner_users ? this.owner_users.length : 0;
  }

  get getLicensesCountActive() {
    return (this.license_is_active && this.license_is_active.license_num) ? this.license_is_active.license_num : 0;
  }

  public getStatusName(status) {
    return STATUS_NAME[status];
  }

  public isJoined(status) {
    return status === STATUS.JOIN;
  }

  public getRoleName(roleId) {
    return COMPANY_ROLE_NAME[roleId];
  }

  public formatDate(date) {
    return moment(date).format(DATE_FORMAT)
  }

  public addNewLicense() {
    this.company_licenses.push(new CompanyLicenseItem({
      id: null,
      license_num: 1,
      applicable_date: null,
    }));
  }
}
